module.exports = __webpack_public_path__ + "img/edit.efe4f99f.png";